export function formatNumber(value: number | string): string {
  return value
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function unformatNumber(value: string): number {
  return Number(value.replace(/[^\d]/g, ""));
}

export function formatElapsedTime(totalSeconds: number): string {
  if (!totalSeconds || totalSeconds < 0) return "0s";

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes > 0) {
    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
  }

  return `${seconds}s`;
};


export function formatTimerUI(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return [h, m, s].map(v => v < 10 ? `0${v}` : v).join(':');
};